import type { FC } from 'react';
import { SkeletonRectangle } from '@george-labs.com/design-system';

const DEFAULT_WIDTH = 316;
const DEFAULT_HEIGHT = 201;

interface Props {
    className?: string;
    width?: number;
    height?: number;
    'data-cy'?: string;
}

export const CardImageSkeleton: FC<Props> = ({
    className,
    width = DEFAULT_WIDTH,
    height = DEFAULT_HEIGHT,
    'data-cy': dataCy,
}) => (
    <div
        className={className}
        // eslint-disable-next-line george/jsx-no-inline-styles
        style={{
            width: '100% !important',
            height: 'auto !important',
            aspectRatio: `${width} / ${height}`,
        }}
        data-cy={dataCy}
    >
        <SkeletonRectangle
            // We are forced to apply a width and height as a pixel number, so we override this with the below classes.
            className="w-100 h-100"
            height={100}
            width={100}
            animated
        />
    </div>
);
